import { __ } from '@wordpress/i18n';

window.addEventListener("DOMContentLoaded", function () {
    function reskinTime(secs) {
        const normalizedSeconds = Number(secs) || 0;
        const hours = Math.floor(normalizedSeconds / 3600);
        const minutes = Math.floor((normalizedSeconds - (hours * 3600)) / 60);
        let seconds = Math.floor(normalizedSeconds - (hours * 3600) - (minutes * 60));
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        return minutes + ':' + seconds;
    }

    function numberMap(value, start1, stop1, start2, stop2) {
        if (stop1 === start1) {
            return start2;
        }
        return ((value - start1) / (stop1 - start1)) * (stop2 - start2) + start2;
    }

    document
        .querySelectorAll(".category-audio .wp-block-audio")
        .forEach(function (audioWrapper, index) {
            audioWrapper.insertAdjacentHTML(
                "afterbegin",
                '<div class="audio-fake-player"> <div class="player-meta"> <span class="current-time">0:00</span> <div class="audio-bar"></div> <span class="total-time">1:15</span> </div> <button type="button" class="play-button"> <i class="fas fa-play" aria-hidden="true"></i> </button> </div>'
            );

            if (!index) {
                audioWrapper.querySelector('.audio-fake-player')?.classList.add('first-fake-audio-element');
            }

            const player = audioWrapper.querySelector("audio");
            const playButton = audioWrapper.querySelector('button.play-button');
            const progress = audioWrapper.querySelector('.audio-bar');
            const fill = document.createElement('div');
            fill.className = 'fill-bar';

            if (!player || !playButton || !progress) {
                return;
            }

            progress.appendChild(fill);
            player.classList.add('hide');
            playButton.setAttribute('aria-label', __('Play audio', 'jeo'));
            progress.setAttribute('aria-label', __('Audio progress', 'jeo'));
            progress.setAttribute('aria-valuemin', '0');
            progress.setAttribute('aria-valuenow', '0');
            progress.setAttribute('role', 'slider');
            progress.setAttribute('tabindex', '0');

            const seekTo = (seconds) => {
                if (!Number.isFinite(player.duration) || player.duration <= 0) {
                    return;
                }
                player.currentTime = Math.max(0, Math.min(player.duration, seconds));
            };

            player.addEventListener('loadedmetadata', function() {
                const totalTime = audioWrapper.querySelector('.total-time');
                if (totalTime) {
                    totalTime.textContent = reskinTime(player.duration);
                }
                progress.setAttribute('aria-valuemax', String(Math.floor(player.duration || 0)));

                playButton.onclick = function() {
                    const shouldPlay = player.paused;
                    if (shouldPlay) {
                        void player.play();
                    } else {
                        player.pause();
                    }

                    const icon = this.querySelector('i');
                    if (icon?.classList.contains('fa-undo')) {
                        icon.classList.remove("fa-undo");
                        icon.classList.add("fa-pause");
                    } else {
                        icon?.classList.toggle("fa-pause", shouldPlay);
                        icon?.classList.toggle("fa-play", !shouldPlay);
                    }
                    this.setAttribute('aria-label', shouldPlay ? __('Pause audio', 'jeo') : __('Play audio', 'jeo'));
                };

                progress.onclick = function(event) {
                    seekTo(numberMap(event.offsetX, 0, this.offsetWidth, 0, player.duration));
                };
                progress.onkeydown = function(event) {
                    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
                        return;
                    }
                    event.preventDefault();
                    seekTo(player.currentTime + (event.key === 'ArrowRight' ? 5 : -5));
                };
            });

            player.addEventListener('ended', function() {
                const icon = audioWrapper.querySelector('i');
                icon?.classList.add("fa-undo");
                icon?.classList.remove("fa-pause");
                playButton.setAttribute('aria-label', __('Replay audio', 'jeo'));
            });

            player.addEventListener("timeupdate", function() {
                const ratio = player.duration ? (player.currentTime / player.duration) * 100 : 0;
                fill.style.width = ratio + '%';
                const currentTime = audioWrapper.querySelector('.current-time');
                const formattedTime = reskinTime(player.currentTime);
                if (currentTime) {
                    currentTime.textContent = formattedTime;
                }
                progress.setAttribute('aria-valuenow', String(Math.floor(player.currentTime || 0)));
                progress.setAttribute('aria-valuetext', formattedTime);
            }, false);
        });
});
